<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input" @submit.prevent="submitForm">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4 v-if="component">Update "{{ component.name }}" OTA Component</h4>
                    <h4 v-else>Add New OTA Component</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData['name']" autofocus :rules="[vRules.required]" label="Name"/>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="formData['type']" :items="[
                                          {value:0, title:'Firmware File'},
                                          {value:1, title:'Resource File'},
                                          ]"
                                      :rules="[vRules.required]" label="Type"/>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="formData['module_index']" :items="[1,2,3,4,5,6]"
                                      :rules="[vRules.required]" label="Module Index"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    productSku: Number,
    component: Object,
});
const formData = reactive({
    valid: false,
    name: props.component?.name ?? null,
    type: props.component?.type ?? null,
    module_index: props.component?.module_index ?? null,
    product_sku_id: props.component?.product_sku_id ?? props.productSku,
});
const emits = defineEmits(['update:modelValue', 'addComponent', 'updateComponent']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

const submitForm = () => {
    errors.value = [];
    if (props.component) {
        send('put', `admin/ota/components/${props.component.id}`, formData)
            .then((response) => {
                snackbar.showSnackbar(response.data.message);
                if (response.data.success) {
                    emits('updateComponent', response.data.data);
                    emits('update:modelValue', false);
                }
            })
            .catch(function (errorResponse) {
                if (errorResponse.response?.data?.errors) {
                    let validationErrors = errorResponse.response.data.errors;
                    Object.keys(validationErrors).forEach((key) => {
                        errors.value.push(validationErrors[key][0]);
                    });
                } else if (errorResponse.response?.data.message) {
                    errors.value.push(errorResponse.response.data.message);
                }
                snackbar.showSnackbar('Something went wrong', 'error');
                document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
            })
    } else {
        send('post', `admin/ota/components`, formData)
            .then((response) => {
                snackbar.showSnackbar(response.data.message);
                if (response.data.success) {
                    emits('addComponent', response.data.data);
                    emits('update:modelValue', false);
                }
            })
            .catch(function (errorResponse) {
                if (errorResponse.response?.data.errors) {
                    let validationErrors = errorResponse.response.data.errors;
                    Object.keys(validationErrors).forEach((key) => {
                        errors.value.push(validationErrors[key][0]);
                    });
                } else if (errorResponse.response?.data.message) {
                    errors.value.push(errorResponse.response.data.message);
                }
                snackbar.showSnackbar('Something went wrong', 'error');
                document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
            })
    }
}

</script>
